import { LocateFixed } from 'lucide-react';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import { DEFAULT_ZOOM, POSITION_CLASSES } from '@/constants';
import { useIsPointVisible } from '@/hooks/useIsPointVisible';
import { usePosition } from '@/hooks/usePosition';

const LocateUserControl = ({ position }: {
  position: string,
}) => {
  const map = useMap();
  const positionClass = (position && POSITION_CLASSES[position as keyof typeof POSITION_CLASSES]) || POSITION_CLASSES.topright;
  const { coords, isLoading, getPosition } = usePosition({ autoFetch: false });

  const handleLocateUser = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    await getPosition();
  };

  useEffect(() => {
    if (coords) {
      map.setView(coords, DEFAULT_ZOOM);
    }
  }, [coords, map]);

  const stillVisible = useIsPointVisible(map, coords ?? [0, 0]);

  return (
    !stillVisible && (
      <div className={positionClass}>
        <div className="leaflet-control">
          <div
            className="px-1 pt-1 mb-3 rounded-md shadow-md"
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.5)',
              color: 'rgba(59, 130, 246, 0.5)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 1)';
              e.currentTarget.style.color = 'rgba(59, 130, 246, 1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.5)';
              e.currentTarget.style.color = 'rgba(59, 130, 246, 0.5)';
            }}
          >
            <button
              className="cursor-pointer leaflet-control-locate-user"
              title="Locate me"
              role="button"
              aria-label="Locate user"
              onClick={handleLocateUser}
              disabled={isLoading}
            >
              <LocateFixed
                size={24}
                className="rounded-md"
              />
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export { LocateUserControl };
